import Constructor from '../constructor'
import Map from './module/map'

class Season extends Constructor(Map) {}

export default Season